import React from 'react';
import Section from '../Services/Section';
import ServicePage from '../Services/ServicePage';
import MetaTags from '../../../helpers/Common/MetaTags';
import { getMetaConfig } from '../../../helpers/Common/metaConfig';

const Services = () => {
    const servicesMeta = getMetaConfig('services');
    
    return (
        <React.Fragment>
            <MetaTags {...servicesMeta} />
            <Section />
            <ServicePage />
        </React.Fragment>
    )
}

export default Services;
